// react
import { MutableRefObject } from 'react';
// @mui
import { GridAggregationFunction } from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';

type Props = {
  apiRef: MutableRefObject<GridApiPremium | null>;
};

export function DeviationFromAverage({ apiRef }: Props) {
  const rows = apiRef.current?.state.rows;
  const totalRowCount = rows?.totalRowCount;
  const totalTopLevelRowCount = rows?.totalTopLevelRowCount;
  const average = (totalRowCount ?? 1) / (totalTopLevelRowCount ?? 1);

  return {
    label: 'Deviation from average',
    apply: ({ values }) => {
      if (values === null) {
        return null;
      }
      let total = 0;
      values.forEach((x) => {
        if (x !== undefined && x !== null) {
          total += 1;
        }
      });

      return (total / (average ?? 1)).toFixed(2);
    },
  } as GridAggregationFunction<any, string>;
}
